import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Paper, Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { toast } from 'react-toastify';
import InventoryList from '../InventoryList';
import useStyles from '../styles';

import useCommonStyles from '../../../../../../commonStyles';
import { UnitsContext } from '../../../../../../Contexts/UnitsContext';
import { TPVAST_CONSTANTS } from '../../../../../../core/constants';
import Loader from '../../../../../../Components/Loader';
import { getTpVastsDoc, createTpVastsDoc, updateTpVastsDoc } from '../../../../../../api/tpVasts';
import PageHeading from '../../../../../../Components/PageHeading';
import { FEATURE_DESCRIPTION } from '../../../../constant';

/**
 * This is initial component that get rendered when we switches to TP VAST CONFIG, here we do main operations, creation/deletion/verification of tpVastConfig object. It also uses other components to render the config data.
 */
const TpVastConfig = () => {
	const {
		tpVastDoc,
		updateTpVastDoc,
		selectedTpValues,
		setSelectedTpValues,
		updateSelectedTpValues,
		tpVastDocEditMode,
		setTpVastDocEditMode,
		previousTpVastDoc
	} = useContext(UnitsContext);
	const { siteRawConfig } = useContext(UnitsContext);
	const {SITE_CONFIG} = FEATURE_DESCRIPTION;
	const classes = useStyles();
	const commonStyleClasses = useCommonStyles();
	const { siteId } = useParams();
	const { FLOOR, DEMAND, PLATFORM } = TPVAST_CONSTANTS.INVENTORY;
	const siteDomain = siteRawConfig.siteDomain;

	/**
	 * @name updateTpVastObjInCouchBase This function verifies the tpVast object and update in the couchbase if validated
	 */
	const updateTpVastObjInCouchBase = async () => {
		try {
			const dataObject = {
				siteId: siteId,
				data: tpVastDoc,
				previousCouchBaseConfig: previousTpVastDoc.current || {},
				mode: tpVastDocEditMode,
				siteDomain: siteDomain
			};
			if (tpVastDocEditMode === TPVAST_CONSTANTS.EDIT_MODES.UPDATE) {
				await updateTpVastsDoc(dataObject);
				toast.success('Updated successfully', {
					position: toast.POSITION.BOTTOM_RIGHT
				});
				previousTpVastDoc.current = structuredClone(tpVastDoc);
			} else {
				await createTpVastsDoc(dataObject);
				setTpVastDocEditMode(TPVAST_CONSTANTS.EDIT_MODES.UPDATE);
				toast.success('Created successfully', {
					position: toast.POSITION.BOTTOM_RIGHT
				});
				const { data } = await getTpVastsDoc(siteId);
				const tpVastUnits = data.data.tpVastsDoc;
				const clonedTpVastUnits = structuredClone(tpVastUnits);
				updateTpVastDoc(clonedTpVastUnits);
				previousTpVastDoc.current = structuredClone(clonedTpVastUnits);
			}
		} catch (err) {
			console.log(err);
			const errMessage = err?.response?.data?.data?.message || err.message;
			toast.error(errMessage || 'Some Error Occured', {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		}
	};

	return (
		<>
			<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
				<PageHeading
					headingName="Third Party Vast Config"
					headingPath={['Dashboard', 'Framerate', 'Third Party Vast Config']}
					description="Manage floor, demand, platform wise vast tags inventory for third party demand partners."
					showInfoButton={true}
					infoMessage={SITE_CONFIG.TP_VAST_CONFIG}
				/>
				<Grid
					item
					xs={12}
					style={{
						display: 'flex',
						justifyContent: 'center'
					}}
				>
					<Button
						variant="contained"
						style={{
							margin: '3rem 0'
						}}
						onClick={() => updateTpVastObjInCouchBase()}
					>
						{tpVastDocEditMode.replace(/_/g, ' ')}
					</Button>
				</Grid>
				<Box className={classes.tpVastConfigClass}>
					<Grid container spacing={5}>
						<Grid item xs={4}>
							<Typography className={commonStyleClasses.heading} fontWeight={600} variant="h4">
								Floors
							</Typography>
							<InventoryList
								inventoryType={FLOOR}
								tpVastDoc={structuredClone(tpVastDoc)}
								updateTpVastDoc={updateTpVastDoc}
								selectedTpValues={structuredClone(selectedTpValues)}
								setSelectedTpValues={setSelectedTpValues}
								updateSelectedTpValues={updateSelectedTpValues}
							/>
						</Grid>
						<Grid item xs={4}>
							<Typography className={commonStyleClasses.heading} fontWeight={600} variant="h4">
								Demand
							</Typography>
							{selectedTpValues[FLOOR] === '' ? (
								<Loader loaderContainerStyle={{ height: '70%' }} />
							) : (
								<InventoryList
									inventoryType={DEMAND}
									tpVastDoc={structuredClone(tpVastDoc)}
									updateTpVastDoc={updateTpVastDoc}
									selectedTpValues={structuredClone(selectedTpValues)}
									setSelectedTpValues={setSelectedTpValues}
									updateSelectedTpValues={updateSelectedTpValues}
								/>
							)}
						</Grid>
						<Grid item xs={4}>
							<Typography className={commonStyleClasses.heading} fontWeight={600} variant="h4">
								Platform
							</Typography>
							{selectedTpValues[DEMAND] === '' ? (
								<Loader loaderContainerStyle={{ height: '70%' }} />
							) : (
								<InventoryList
									inventoryType={PLATFORM}
									tpVastDoc={structuredClone(tpVastDoc)}
									updateTpVastDoc={updateTpVastDoc}
									selectedTpValues={structuredClone(selectedTpValues)}
									setSelectedTpValues={setSelectedTpValues}
									updateSelectedTpValues={updateSelectedTpValues}
								/>
							)}
						</Grid>
					</Grid>
				</Box>
			</Paper>
		</>
	);
};

export default TpVastConfig;
